import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { 
  APPLICATION_MODE_NEW, 
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, 
  ERROR_CODE, 
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, 
  ROUTE_PATH 
} from "../../app/constants";
import { useDispatch, useSelector } from "react-redux";
import { ValidateString } from "../../app/utils";
import { Button, ErrorMark } from "../../components/RegularComponents";
import {
  ERROR_STRING,
  VALIDATION_TYPE,
  VALIDATION_ERROR,
  emailErrorString,
  phoneNumberErrorString,
} from "../../app/errors";
// import { ERROR_STRING } from "../../app/errors";

import { ErrorWithString } from "../../components/RegularComponents";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";
import styles from "./ml.module.scss";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils';

const MORTGAGE_APPLICATION_PROPERTY = "mainBusinessContact";
export const CompanyContactInformation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW

  const mainBusinessContact = useSelector(
    (state) => state.primaryAgencyApplication.application.businessLicenceData.mainBusinessContact 
  );

  const [phone, setPhone] = useState(mainBusinessContact.phoneNumber);
  const [phoneError, setPhoneError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [email, setEmail] = useState(mainBusinessContact.emailAddress);
  const [emailError, setEmailError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false)

  useEffect(() => {
    phoneError === VALIDATION_ERROR.NO_ERROR &&
    emailError === VALIDATION_ERROR.NO_ERROR
      ? setShowValidationError(false)
      : setShowValidationError(true);
  }, [phoneError, emailError]);

  const validateData = () => {
    const ret1 = ValidateString(phone, VALIDATION_TYPE.PHONE_NUMBER);
    setPhoneError(ret1);

    const ret2 = ValidateString(email, VALIDATION_TYPE.EMAIL);
    setEmailError(ret2);

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR && ret2 === VALIDATION_ERROR.NO_ERROR
    );
  };

  const handleSave = () => {
    //reset errors
    setShowValidationError(false);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
    setEmailError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return false;
    }

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: {
        ...mainBusinessContact,
        phoneNumber: phone,
        emailAddress : email
      }
    };
    dispatch(setMortgageProperty(update));

    return true
  }

  const handleNext = () => {
    if (handleSave()) {
      dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
      .then(data => {
        const nextRoutePath = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) ? 
                              ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
        dispatch(
          push(`${nextRoutePath}${ROUTE_PATH.ML_COMPANY_FINANCIAL_LOCATION}`)
        );
      })
      .catch(err => {
        setApplicationSaveError(true)
      })
    }
  };

  const handleSaveandClose = () => {
    if (handleSave())
      onEditSave()
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(VALIDATION_ERROR.NO_ERROR);
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar 
                {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW} />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>Company contact information</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              Your company contact information will appear on the Nova Scotia public register of mortgage companies.  Enter the information you want to appear on the register.
            </div>
          </div>
        </>
      )}

      {/* Phone */}
      <div style={{ marginTop: "30px" }} className="row">
        <div className="col-lg-8">
          <div 
            className={
              "ns-fieldset" +
              ((phoneError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            } 
          >
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-lender-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-lender-licence-number-text"}
            >
              Phone
            </label>
            {phoneError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-lender-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(phoneNumberErrorString(phoneError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (phoneError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-lender-licence-number-text"}
              name={"mortgage-lender-licence-number-text"}
              value={phone}
              onChange={handlePhoneChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Email */}
      <div className="row">
        <div className="col-lg-8">
          <div 
            className={
              "ns-fieldset" +
              ((emailError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            } 
          >
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-lender-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-lender-licence-number-text"}
            >
              Email
            </label>
            {emailError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"mortgage-lender-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(emailErrorString(emailError))}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (emailError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"mortgage-lender-licence-number-text"}
              name={"mortgage-lender-licence-number-text"}
              value={email}
              onChange={handleEmailChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Save and continue */}
      <div className="row">
        <div className={"col-lg-4" + ((applicationSaveError || showValidationError) ? " has-error" : "")}>
          <Button
            className={`${styles["question_button"]} btn-lg btn-default`}
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            onClick={!isModal ? handleNext : handleSaveandClose}
            text={!isModal ? "Save and next" : "Save and close"}
          />

          {(applicationSaveError || showValidationError) && ErrorMark()}
          {showValidationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
          {applicationSaveError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
